import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormatLanguagePipe } from './format-language.pipe';
import { FormatPhoneNumberPipe } from './format-phone-number.pipe';

@NgModule({
  declarations: [FormatLanguagePipe, FormatPhoneNumberPipe],
  imports: [CommonModule],
  exports: [FormatLanguagePipe, FormatPhoneNumberPipe],
})
export class CustomPipesModule {}
